import { MentoringProgramMatchingType } from 'redux/schemas/models/mentoring-programs';
import { CustomCommunicationMessageType } from 'redux/schemas/models/mentorship-program-custom-communications';
import { config } from '@config/pendo.config.json';

export const DEFAULT_SESSION_NUDGE_WEEKS = 4;

type MessageTypeMapEntry = {
  title: string;
  sentOn: string;
  tooltip?: string;
  dataQa: string;
};

const getMatchAnnouncementSentOnTranslation = (
  matchingType: MentoringProgramMatchingType,
  aliases: any,
  translationBase: any,
) => {
  if (matchingType === MentoringProgramMatchingType.AUTOMATED_MATCHING) {
    return translationBase.MATCH_ANNOUNCEMENT.SENT_ON.ASSIGNED();
  }
  if (matchingType === MentoringProgramMatchingType.PARTICIPANT_DRIVEN) {
    return translationBase.MATCH_ANNOUNCEMENT.SENT_ON.PARTICIPANT_DRIVEN(
      aliases,
    );
  }
  return '';
};

const messageTypeMap = (
  t: any,
  matchingType?: MentoringProgramMatchingType,
  aliases?: any,
  weeksCount: number = DEFAULT_SESSION_NUDGE_WEEKS,
): Partial<Record<CustomCommunicationMessageType, MessageTypeMapEntry>> => {
  const translationBase = t.MENTORING_PROGRAMS.COMMUNICATIONS.MESSAGE_TYPES;
  const dataQATag = config.pendo.athena.mentorshipProgram.communications.editCommunicationModal
    .delivery.messageType;

  return {
    [CustomCommunicationMessageType.WELCOME_MESSAGE]: {
      title: translationBase.WELCOME_MESSAGE.TITLE(),
      sentOn: translationBase.WELCOME_MESSAGE.SENT_ON(),
      dataQa: dataQATag.welcomeMessageOption,
    },
    ...(matchingType !== MentoringProgramMatchingType.PARTICIPANT_DRIVEN && {
      [CustomCommunicationMessageType.PROFILE_COMPLETION_REMINDER]: {
        title: translationBase.PROFILE_COMPLETION_REMINDER.TITLE(),
        sentOn: translationBase.PROFILE_COMPLETION_REMINDER.SENT_ON(),
        dataQa: dataQATag.profileCompletionReminderOption,
      },
    }),
    [CustomCommunicationMessageType.MATCH_ANNOUNCEMENT]: {
      title: translationBase.MATCH_ANNOUNCEMENT.TITLE(),
      sentOn:
        matchingType && aliases
          ? getMatchAnnouncementSentOnTranslation(
            matchingType,
            aliases,
            translationBase,
          )
          : '',
      dataQa: dataQATag.matchAnnouncementOption,
    },
    [CustomCommunicationMessageType.SESSION_NUDGE]: {
      title: translationBase.SESSION_NUDGE.TITLE(),
      sentOn: translationBase.SESSION_NUDGE.SENT_ON(weeksCount),
      tooltip: translationBase.SESSION_NUDGE.TOOLTIP(),
      dataQa: dataQATag.sessionNudgeOption,
    },
  };
};

export default messageTypeMap;
